function n(){return!!/Firefox\/([0-9.]+)(?:\s|$)/.exec(window.navigator.userAgent)}function e(){return!!window.MSInputMethodContext&&!!document.documentMode}export{n as isFirefox,e as isIE11};
